<template>
  <div class="swiper_s">
    <div class="swiper_s__container">
      <div class="titr">
        <p class="titr--p">
          پیشنهاد های<br />
          شگفت<br />
          انگیز
        </p>
        <router-link to="/special-offer" style="margin-top: 2em" class="my_btn">
          مشاهده همه &nbsp; &rsaquo;</router-link
        >
      </div>

      <swiper class="swiper" ref="swiper" :options="swiperOption">
        <swiper-slide
          class="swiper-item"
          :key="(item, index)"
          v-for="(item, index) in this.$store.state.index.special_offer"
        >
          <router-link
            :to="{ name: 'detail', params: { id: item.slug } }"
            class="swiper-item__link"
          >
            <img
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
              :src="item.image"
              :alt="item.name"
              class="swiper-item__link_img"
            />
            <!-- <div
              class="swiper-lazy-preloader swiper-lazy-preloader-black"
            ></div> -->
            <p class="swiper-item__link_name">
              {{ item.name }}
            </p>
            <div class="dec_pri">
              <p class="swiper-item__link_prise" v-if="item.discount != 0">
                {{ item.price.toLocaleString("fa").toPersianDigits() }} تومان
              </p>
              <p class="swiper-item__link_dec" v-if="item.discount != 0">
                {{ item.discount.toLocaleString("fa").toPersianDigits() }}٪
              </p>
            </div>
            <p v-if="item.discount != 0" class="swiper-item__link_prise_dec">
              {{ item.dis_price.toLocaleString("fa").toPersianDigits() }}
              تومان
            </p>
            <p v-if="item.discount == 0" class="swiper-item__link_prise_dec">
              {{ item.price.toLocaleString("fa").toPersianDigits() }}
              تومان
            </p>
          </router-link>
        </swiper-slide>
        <swiper-slide class="swiper-item last">
          <router-link to="/special-offer" class="last__text">
            مشاهده همه &nbsp;
            <div class="last__sign">
              <font-awesome-icon icon="arrow-left" />
            </div>
          </router-link>
        </swiper-slide>
        <div
          class="swiper-button-prev"
          slot="button-prev"
          @click="prev()"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="next()"
        ></div>
      </swiper>
      <hr />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      lazyLoad: true,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  created() {
    this.lazyLoad = false;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 3,
        // loop: true,
        loopFillGroupWithBlank: true,
        lazy: true,
        breakpoints: {
          1500: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          875: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          685: {
            freeMode: true,
            slidesPerView: 2,
            spaceBetween: 12,
          },
          320: {
            freeMode: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            // spaceBetween: 150
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "./base.scss";
.my_btn {
  padding: 0.75em 2em;
  border: 1px solid var(--main-color);
  border-radius: 10px;
  text-decoration: none;
  color: var(--main-color);
  @media screen and (max-width: 900px) {
    padding: 0.5em 0.75em;
    font-size: 0.7em;
    border-radius: 5px;
  }
  @media screen and (max-width: 800px) {
    padding: 0.5em 0.75em;
    font-size: 0.7em;
    border-radius: 5px;
  }
  @media screen and (max-width: 500px) {
    padding: 0.5em 1em;
    font-size: 0.6em;
    border-radius: 5px;
  }
}
.last {
  // background: brown;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  a {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
  }
  &__sign {
    border: 1px solid orange;
    font-size: 2em;
    padding: 0.5em;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding-top: 0.5em;
    color: orange;
    margin-bottom: 1em;
  }
  &__text {
    color: var(--font-color);
  }
}
.titr {
  flex-direction: column;
  width: 20%;
  height: 80%;
  margin-left: 0;
  // background: red;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 900px) {
    width: 20%;
    margin-right: 0.95em;
  }
  @media screen and (max-width: 800px) {
    width: 20%;
    margin-right: 0.95em;
  }
  @media screen and (max-width: 500px) {
    width: 30%;
    margin-right: 0.95em;
  }
  &--p {
    font-family: "lalezar";
    color: var(--main-color);
    font-size: 2em;
    text-align: center;
    @media screen and (max-width: 900px) {
      font-size: 1.3em;
    }
    @media screen and (max-width: 800px) {
      font-size: 1em;
    }
    @media screen and (max-width: 500px) {
      font-size: 1em;
    }
  }
}
.swiper {
  width: 98%;
  // background: blue;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  margin-left: 1.2em;
  padding-left: 0.8em;
  padding-right: 0.5em;
  padding-top: 1.5em;

  // background: blueviolet;
}
.swiper_s {
  // background: red;
  height: 530px;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: rtl;
  // // position: absolute;
  // // top: 150px;
  margin-top: 7.8em;
  // // width: 100%;
  // // height: 100vh;
  // // padding-right: 20em;
  // // background: var(--sub-color);
  box-shadow: 0 0 5px black;
  @media screen and (max-width: 900px) {
    height: 500px;
  }
  @media screen and (max-width: 800px) {
    height: 500px;
  }
  @media screen and (max-width: 500px) {
    height: 450px;
  }
  &__container {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to left top,
      #ef3954,
      #f44f5f,
      #f8626b,
      #fc7377,
      #ff8383
    );
    // background: blue;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.swiper-item {
  height: 400px !important;
  // width: 333px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.274);
  width: 315px !important;

  @media screen and (max-width: 658px) {
    height: auto;
    // background: red;
    padding-right: 1em;
    // width: 250px !important;
    // margin-right: 1em;
  }
  &__link {
    width: 100%;
    height: 100%;
    // background: blue;
    text-decoration: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    &_img {
      margin-top: 2em;
      width: 150px;
      height: 150px;
      @media screen and (max-width: 500px) {
        width: 150px;
        height: 150px;
      }
    }
    &_name {
      // background: red;
      color: var(--font-color);
      width: 100%;
      padding-right: 1em;
      margin-top: 4em;
      font-size: 0.8em;
      @media screen and (max-width: 500px) {
        font-size: 0.7em;
      }
    }
    &_prise {
      font-size: 0.9em;
      text-decoration: line-through;
      padding-left: 0.9em;
      text-align: left;
      width: 100%;
      // margin-top: 4em;
      color: var(--font-color);
    }
    &_dec {
      margin-right: auto;
      margin-left: 0.8em;
      margin-top: 0.2em;
      color: var(--main-color);
      background: var(--sub-color);
      border-radius: 20px;
      padding: 0.4em 0.8em;
      font-size: 0.8em;
    }
    &_prise_dec {
      letter-spacing: 0.05em;
      word-spacing: 0.2em;
      font-size: 1.2em;
      // text-decoration: line-through;
      padding-left: 0.9em;
      text-align: left;
      width: 100%;
      // margin-top: 4em;
      color: var(--font-color);
    }
  }
}
.dec_pri {
  margin-top: 2em;
  justify-content: center;
  align-items: center;
  // background: red;
  display: flex;
  width: 100%;
  height: 50px;
}
.swiper-button-next {
  border-radius: 50%;
  font-size: 0.5em;
  background-color: var(--sub-color);
  // right: 10px;
  padding: 18px;
  top: 50%;
  transform: translate(-25%, -50%);
  color: var(--main-color) !important;
  border: 1px solid var(--main-color);
  fill: var(--main-color) !important;
  stroke: var(--main-color) !important;
  @media screen and (max-width: 900px) {
    // font-size: 1em;
    display: none;
  }
}
.swiper-button-prev {
  border-radius: 50%;
  font-size: 0.5em;
  background-color: var(--sub-color);
  // right: 10px;
  padding: 18px;
  top: 50%;
  transform: translate(25%, -50%);
  color: var(--main-color) !important;
  border: 1px solid var(--main-color);
  fill: var(--main-color) !important;
  stroke: var(--main-color) !important;
  @media screen and (max-width: 900px) {
    // font-size: 1em;
    display: none;
  }
}
:root {
  --swiper-navigation-size: 17px;
  --swiper-navigation-size: 17px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/components/swiper1.vue